import { connectWebSocket } from 'src/api/client';

type WebSocketHandlers = {
  onMessage?: (event: MessageEvent) => void;
  onError?: (event: Event) => void;
  onClose?: (event: CloseEvent) => void;
};

export function createAppWebSocket(handlers: WebSocketHandlers = {}, reconnectDelay = 30000) {
  let ws: WebSocket | null = null;
  let reconnectTimeout: number | null = null;

  const clearReconnect = () => {
    if (reconnectTimeout !== null) {
      window.clearTimeout(reconnectTimeout);
      reconnectTimeout = null;
    }
  };

  const scheduleReconnect = () => {
    clearReconnect();
    reconnectTimeout = window.setTimeout(setup, reconnectDelay);
  };

  const setup = () => {
    clearReconnect();

    if (ws) {
      ws.onclose = null;
      ws.onerror = null;
      ws.close();
      ws = null;
    }

    try {
      const socket = connectWebSocket();
      if (!socket) return;

      ws = socket;

      ws.onmessage = (event: MessageEvent) => {
        handlers.onMessage?.(event);
      };

      ws.onclose = (event: CloseEvent) => {
        handlers.onClose?.(event);
        scheduleReconnect();
      };

      ws.onerror = (event: Event) => {
        handlers.onError?.(event);
      };
    } catch (error) {
      console.error('WebSocket Error: ', error);
      scheduleReconnect();
    }
  };

  setup();

  const close = () => {
    clearReconnect();
    if (ws) {
      ws.close();
      ws = null;
    }
  };

  return {
    close,
    reconnect: setup
  };
}
